import MicroscopyCropInsertion from './MicroscopyCropInsertion';
import FigurePanelIdProvider from './FigurePanelIdProvider';
import {FilesystemStore} from './Contexts';
import A from './ActionCreators';
import G from './Getters';
import { useState } from 'react';
import { useSelector, useDispatch, useStore } from 'react-redux';
import useFigurePanelId from './useFigurePanelId';
import { flattenObject } from './utils';




export default function ImageInsertionModal({

  useCase,
  onClose, 
  mode, 
  onEvent,
  cellLocation,
  cellData,
  initialState,
}){


  const dispatch = useDispatch();

  const store = useStore();
  const state = store.getState();

  
  

  const figurePanelId = useFigurePanelId();


  let defaultTemplate = G.getFigurePanelTemplate(state,{figurePanelId, cellLocation}); 


  const [ focusedFsItemIds, setFocusedFsItemIds ] = useState([]);
  const focusedImageSetId = focusedFsItemIds?.[0]?._id;

  const [ focusedFsItems, setFocusedFsItems ] = useState([]);


  /* at the end of this, we DO need to have SOME image set to work with */

  

  const [loci, setLoci] = useState();



  let hasValueAlredy = cellData?.valueType === "crop" && cellData?.expandable 

 
    
  return (
    <>
      <FigurePanelIdProvider figurePanelId={figurePanelId}>
        {false && <div>{JSON.stringify(cellData)}</div>}
          <MicroscopyCropInsertion {...{
            initialState,
            figurePanelId,
            cellData,
            cellLocation,
            defaultTemplate,
            useCase,
            onEvent,

            //DEFAULT_ARGS.... which contains
            //
            
            onSubmit:({regions,annotationId,imageSetId, imageIdsByChannel,template}) => {


              let properties = flattenObject({
                imageIdsByChannel,
                regions
              })



              if( hasValueAlredy ){
              
                dispatch(A.setCellsValueProperties({
                  figurePanelId,
                  cells:[cellLocation],
                  properties
                }))

              }else if( Object.keys(regions).length > 0 ){
                dispatch(A.setCellsValue({
                  figurePanelId,
                  cells:[cellLocation],
                  value:{
                    //annotationId:regions.main,
                    valueType:"crop",
                    regions,
                    imageIdsByChannel,

                  }
                }));
              }

              onClose();
            }
          }}/>
      </FigurePanelIdProvider>
    </>
  )
  
}
